import Colors from '../../scss/riseup-js-colors.module.scss';

export const COLOR_VARIANTS = {
  BLUE: 'blue',
  YELLOW: 'yellow',
  GREEN: 'green',
  PINK: 'pink',
  GRAY: 'gray',
  ORANGE: 'orange',
};

export const COLORS = {
  blue: {
    background: Colors.riseupBlue,
    icon: Colors.riseupLightBlue,
  },
  yellow: {
    background: Colors.riseupYellow,
    icon: Colors.riseupLightYellow,
  },
  green: {
    background: Colors.riseupDarkGreen,
    icon: Colors.riseupLightGreen,
  },
  pink: {
    background: Colors.riseupRed,
    icon: Colors.riseupLightRed,
  },
  gray: {
    background: Colors.riseupGray3,
    icon: Colors.riseupWhite,
  },
  orange: {
    background: Colors.riseupLightOrange,
    icon: Colors.riseupOrange,
  }
};

export const VARIANTS = Object.values(COLOR_VARIANTS);
